import { CheckListLineItem } from '@backrs_ui/common-ui/src/atoms/CheckListLineItem';

import { Box, Typography, SxProps, Theme } from '@mui/material';

type ProfileChecklistProps = Readonly<{
  title: string;
  checklistItems: {
    title: string;
    description: string;
    onClick: () => void;
  }[];
}>;

export const ProfileChecklist = ({ title, checklistItems }: ProfileChecklistProps) => {
  return (
    <Box sx={containerStyle}>
      <Box sx={checklistTitleContainerStyle}>
        <Typography variant="text-lg-semibold" sx={checklistTitleStyle}>
          {title}
        </Typography>
      </Box>
      <Box sx={checklistItemsContainerStyle}>
        {checklistItems.map((item) => (
          <CheckListLineItem key={item.title} {...item} bottomBorder={true} />
        ))}
      </Box>
    </Box>
  );
};

const containerStyle: SxProps<Theme> = ({ backrs }) => ({
  outline: `1px solid ${backrs.colors['Colors/Base/Black']}`,
  boxShadow: backrs.shadows['shadow-xs'],
  borderRadius: backrs.radius['radius-md'],
  minWidth: {
    xs: '100%',
    md: `calc(50% - ${backrs.spacing['spacing-4xl']})`,
  },
  maxWidth: {
    xs: '100%',
    md: `calc(50% - ${backrs.spacing['spacing-4xl']})`,
  },
});

const checklistTitleContainerStyle: SxProps<Theme> = ({ backrs }) => ({
  padding: backrs.spacing['spacing-xl'],
  backgroundColor: backrs.colors['Colors/Foreground/fg-brand-secondary'],
  borderTopLeftRadius: backrs.radius['radius-md'],
  borderTopRightRadius: backrs.radius['radius-md'],
  outline: `1px solid ${backrs.colors['Colors/Base/Black']}`,
});

const checklistTitleStyle: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary-on-brand'],
});

const checklistItemsContainerStyle: SxProps<Theme> = ({ backrs }) => ({
  backgroundColor: backrs.colors['Colors/Base/White'],
  padding: backrs.spacing['spacing-xl'],
  borderBottomLeftRadius: backrs.radius['radius-md'],
  borderBottomRightRadius: backrs.radius['radius-md'],
});
